module.exports = __webpack_public_path__ + "fonts/rawline-700-webfont.818edf7.woff";